import React from 'react';
import { Link } from 'react-router-dom';
export function IntroSection() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-261">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-262">
        {/* LEFT COLUMN */}
        <div data-id="element-263">
          <p className="text-xs font-bold uppercase mb-4" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-264">
            DMV's Trusted Tire Shop
          </p>
          <h2 className="font-black text-black text-3xl sm:text-4xl leading-tight mb-6" data-id="element-265">
            Ameritech Tires – Tire Sales, Installation &amp; Auto Service in the
            DMV
          </h2>
          <p className="text-base leading-relaxed mb-8" style={{
          color: '#616365'
        }} data-id="element-266">
            Ameritech Tires is a top-notch tire and automotive service provider
            serving the DMV area. With the philosophy of making our customers'
            lives convenient, we offer tire sales, installation, rotation, flat
            repair, free tire checks, and 24/7 emergency roadside assistance. No
            appointment needed — just drive in at any of our 3 locations.
          </p>
          <div className="flex gap-4 flex-wrap" data-id="element-267">
            <Link to="/services" className="font-bold text-sm px-7 py-3.5 transition-colors duration-200" style={{
            border: '2px solid #CC0000',
            color: '#CC0000'
          }} onMouseEnter={e => {
            e.currentTarget.style.background = '#CC0000';
            e.currentTarget.style.color = '#ffffff';
          }} onMouseLeave={e => {
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.color = '#CC0000';
          }} data-id="element-268">
              Our Services
            </Link>
            <a href="tel:3012549001" className="font-bold text-sm px-7 py-3.5 text-white transition-colors duration-200" style={{
            background: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-269">
              (301) 254-9001
            </a>
          </div>
        </div>

        {/* RIGHT COLUMN — two images */}
        <div className="grid grid-cols-2 gap-3" data-id="element-270">
          <div className="overflow-hidden rounded-sm h-64" data-id="element-271">
            <img src="https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?w=500&q=80" alt="Ameritech Tires service" className="w-full h-full object-cover" data-id="element-272" />
          </div>
          <div className="overflow-hidden rounded-sm h-64" data-id="element-273">
            <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=500&q=80" alt="Ameritech Tires shop" className="w-full h-full object-cover" data-id="element-274" />
          </div>
        </div>
      </div>
    </section>;
}